import React, { useState, useEffect, useRef } from 'react';
import QandA from './QandA'; // Импортируем компонент QandA
import TaskList from './TaskList'; // Импортируем компонент TaskList
import { useSelector } from "react-redux";
import { ReactComponent as Close } from '../assets/Back.svg';


const Sidebar = ({ selectedDate }) => {
    const [isOpen, setIsOpen] = useState(false); // Состояние для управления открытием боковой панели
    const [startX, setStartX] = useState(0); // Начальная позиция касания
    const [translateX, setTranslateX] = useState(0); // Позиция для трансформации
    const activeTab = useSelector((state) => state.tabs.activeTab); // Получаем текущую вкладку из Redux
    const sidebarRef = useRef(null); // Создаем реф для боковой панели
    const [backButtonPressed, setBackButtonPressed] = useState(false); // Состояние для кнопки "Назад"

    const toggleSidebar = () => {
        setIsOpen(!isOpen); // Переключаем состояние
    };

    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX); // Сохраняем начальную позицию касания
    };

    const handleTouchMove = (e) => {
        const deltaX = e.touches[0].clientX - startX; // Вычисляем смещение
        if (deltaX > 120) { // Если смещение положительное
            setIsOpen(false);
            setBackButtonPressed(true);
        }
    };

    const handleTouchToggleMove = (e) => {
        const deltaX = e.touches[0].clientX - startX; // Вычисляем смещение
        if (deltaX <= 0) { // Если смещение положительное
            setTranslateX(deltaX); // Устанавливаем смещение
        }
    };

    const handleTouchEnd = () => {
        const screenWidth = window.innerWidth; // Получаем ширину экрана
        const threshold = -(screenWidth / 2); // Порог для открытия/закрытия
        if (translateX < threshold) {
            const openPosition = -translateX; // Текущая позиция для открытия
            setIsOpen(true); // Открываем боковую панель

            sidebarRef.current.style.transition = '0.3s ease'; // Применяем плавный переход
            sidebarRef.current.style.transform = `translateX(${openPosition}px)`; // Анимация открытия

        } else if (translateX > threshold) {
            setIsOpen(false); // Закрываем боковую панель
            if (sidebarRef.current) {
                sidebarRef.current.style.transition = 'transform 0.3s ease'; // Применяем плавный переход
                sidebarRef.current.style.transform = 'translateX(0)'; // Возвращаем в исходное положение
            }
        }
        setTranslateX(0); // Сбрасываем смещение
        if (sidebarRef.current) {
            setTimeout(() => {
                sidebarRef.current.style.transition = 'right 0.3s ease'; // Убираем анимацию
            }, 300); // Задержка должна совпадать с длительностью анимации
        }
    };

    const handleBackButtonClick = () => {
        setBackButtonPressed(true); // Изменяем состояние кнопки "Назад"
        toggleSidebar(); // Закрываем боковую панель
    };

    // Эффект для управления прокруткой страницы
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return (
        <div
            ref={sidebarRef}
            className={`sidebar ${isOpen ? 'active' : ''}`}
            style={{
                transform: `translateX(${translateX}px)`, // Динамическое управление позицией
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
        >
            <div className="sidebar-toggle"
                onClick={toggleSidebar}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchToggleMove}
                onTouchEnd={handleTouchEnd}>
                <div className="toggle-container">
                    <div className={`toggle-bar ${isOpen ? 'active' : ''}`}></div>
                </div>
            </div>

            <div className="close-button" onClick={handleBackButtonClick}>
                <Close />
            </div>

            <div className="sidebar-content">
                {activeTab === 'plan' ? (
                    <TaskList selectedDate={selectedDate} onBackButtonClick={setBackButtonPressed} backButtonPressed={backButtonPressed} />
                ) : (
                    <QandA selectedDate={selectedDate} onBackButtonClick={setBackButtonPressed} backButtonPressed={backButtonPressed} />
                )}
            </div>
        </div>
    );
};

export default Sidebar; 